import clsx from 'clsx';
import { baseButtonClass } from '../index';

interface Props extends BaseProps {
  className?: string;
  color?: string;
  direction: 'up' | 'down' | 'left' | 'right';
  size?: StandardSizes;
}

export const Triangle = ({
  className,
  color,
  direction = 'up',
  size = 'lg',
  ...rest
}: Props) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(
        className,
        classes.wrapper.size[size][direction],
        classes.wrapper[direction],
        { 'scale-90': window.devicePixelRatio > 1 }
      )}
    >
      <button
        style={{ background: color }}
        className={clsx(
          'absolute',
          baseButtonClass,
          classes.size[size],
          classes.direction[direction],
          classes.position[direction][size]
        )}
        {...rest}
      />
    </div>
  );
};

const useStyles = () => {
  const overflow = 'relative overflow-hidden inline-block rounded';

  return {
    wrapper: {
      up: `${overflow} mt-auto mx-auto`,
      down: `${overflow} mb-auto mx-auto`,
      left: `${overflow} ml-auto my-auto`,
      right: `${overflow} mr-auto my-auto`,
      size: {
        sm: {
          up: 'w-8 h-5',
          down: 'w-8 h-5',
          left: 'w-6 h-12',
          right: 'w-6 h-12',
        },
        md: {
          up: 'w-6 h-6',
          down: 'w-6 h-6',
          left: 'w-7 h-12',
          right: 'w-7 h-12',
        },
        lg: {
          up: 'w-12 h-7',
          down: 'w-12 h-7',
          left: 'w-7 h-12',
          right: 'w-7 h-12',
        },
      },
    },
    direction: {
      up: `rotate-45 transform origin-bottom-left`,
      down: `-rotate-45 transform origin-top-left`,
      left: `-rotate-45 transform origin-top-right`,
      right: `rotate-45 transform origin-top-left`,
    },
    position: {
      up: {
        sm: 'bottom-[6px] -left-[1px] active:-translate-y-[2px]',
        md: 'bottom-[6px] left-[1px]',
        lg: 'bottom-[6px] left-[1px]',
      },
      down: {
        sm: 'top-[2px] -left-[1px] active:-translate-y-[2px]',
        md: '',
        lg: 'top-[2px] left-[1px]',
      },
      left: {
        sm: '',
        md: '',
        lg: 'top-0 right-[6px]',
      },
      right: {
        sm: '',
        md: '',
        lg: 'top-0 left-[3px]',
      },
    },
    size: {
      sm: 'h-6 w-6',
      md: 'h-7 w-7',
      lg: 'h-8 w-8',
    },
  };
};
